<template>
  <a class="phone" :href="'tel:' + telLink">{{ phone | formatted }}</a>
</template>

<script>
  export default {
    name: 'Phone',
    props: {
      phone: {
        type: String,
        default: '+78127701616'
      }
    },
    computed: {
      telLink: ({ phone }) => '+' + phone.replace(/[^0-9.]/g, '')
    },
    filters: {
      formatted (phone) {
        phone = '+' + phone.replace(/[^0-9.]/g, '')
        return phone.replace(/(\+\d)(\d{3})(\d{3})(\d{2})(\d{2})/g, '$1 ($2) $3-$4-$5').replace('+7', '8')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Phone.vue